export const regPlate = new RegExp(/^[A-Z]{3}-?(?:[0-9][0-9A-Z][0-9]{2}|49CC)$/);

export function isPlateInvalid(value: string) {
    return value == '' || value.length > 7 || !regPlate.test(value);
}

export function isPlateValid(plate: string): boolean {
    return regPlate.test(plate);
}
